import { RootState } from '..';
import { getNestedField } from '../utils';

export const getAuth =
  (state: RootState) =>
  <T extends FlattenKeys<AuthState>>(field: T) =>
    getNestedField(state.auth, field) as DeepType<AuthState, T>;

export const getSubject = (state: RootState) => () => +state.auth.profile.sub;

export const authenticated = (state: RootState) => () =>
  state.auth.authenticated;
export const getToken = (state: RootState) => () => state.auth.token;

const authGetters = (state: RootState) => ({
  getAuth: getAuth(state),
  getSubject: getSubject(state),
  authenticated: authenticated(state),
  getToken: getToken(state),
});

export default authGetters;
